export enum HelpPageStatusEnum {
  Draft = 0,
  Published = 1,
  Archived = 2,
}
